module.exports = __webpack_public_path__ + "media/ש_שווא.1b7b105b.mp3";